import { render, staticRenderFns } from "./teacher-edit.vue?vue&type=template&id=93a46e08&scoped=true"
import script from "./teacher-edit.vue?vue&type=script&lang=js"
export * from "./teacher-edit.vue?vue&type=script&lang=js"
import style0 from "./teacher-edit.vue?vue&type=style&index=0&id=93a46e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a46e08",
  null
  
)

export default component.exports